import { AreaTooltipContent } from '@/lib/Charts/common';
import { FC, useMemo } from 'react';
import { PolarAngleAxis, RadialBar, RadialBarChart, ResponsiveContainer, Tooltip } from 'recharts';
import { twMerge } from 'tailwind-merge';
import { DestinationChartItem } from '../types';
import { DESTINATIONS_CHART_STROKE_WIDTH } from './constants';
import { HomeDestinationsChartLabel } from './HomeDestinationsChartLabel';

type HomeDestinationsChartProps = {
  data: DestinationChartItem[];
  activeTotal: number;
  className?: string;
};

export const HomeDestinationsChart: FC<HomeDestinationsChartProps> = ({ data, activeTotal, className }) => {
  const total = useMemo(() => data.reduce((sum, status) => sum + status.value, 0), [data]);

  return (
    <div className={twMerge('flex items-center justify-center', className)}>
      <ResponsiveContainer>
        <RadialBarChart data={data} startAngle={90} endAngle={-270} innerRadius={'55%'} outerRadius={'100%'} barSize={DESTINATIONS_CHART_STROKE_WIDTH}>
          <RadialBar background dataKey='value' cornerRadius={DESTINATIONS_CHART_STROKE_WIDTH / 2} animationDuration={2000} animationBegin={0} tabIndex={-1} />
          <PolarAngleAxis type='number' domain={[0, total]} angleAxisId={0} tick={false} />
          <Tooltip content={AreaTooltipContent} cursor={{ stroke: 'var(--brand-700)' }} />
        </RadialBarChart>
      </ResponsiveContainer>
      <HomeDestinationsChartLabel total={activeTotal} />
    </div>
  );
};
